import { Box, Direction, useMediaQuery, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import { CcfHeader, CcfQueueIcon, useTranslator } from '@nice-ccf/ui-controls';
import { getApplicationDirection } from '../global.app.slice';
import { CcfQueueCounterChannels } from './ccf-queue-counter-channels';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    QueueCounterCard: {
      width: '100%',
      height: '100%',
      background: `${theme.palette.background.light} 0% 0% no-repeat padding-box`,
      boxShadow: `0px 1px 3px ${theme.palette.boxshadow.main}`,
      border: `1px solid ${theme.palette.border.main}`,
      [theme.breakpoints.up('xl')]: {
        borderRadius: '6px',
      },
      opacity: 1,
      marginRight: '12px',
      transition: 'all 0.5s ease',
      display: 'flex',
      flexDirection: 'column',
      '& .MuiOutlinedInput-input': {
        ...theme.typography.h4,
      },
    },
    queueCounterHeader: {
      background: `${theme.palette.background.level1} 0% 0% no-repeat padding-box`,
      borderRadius: '5px 5px 0px 0px',
      opacity: 1,
      paddingTop: '10px',
      paddingBottom: '0.5rem',
      paddingLeft: '5px',
      '& label': {
        color: theme.palette.text.secondary,
        marginLeft: '5px',
        fontWeight: 'bold',
        marginTop: '0px !important',
      },
    },
  })
);
/**
 * Component for ccf queueCounter
 * @param props - QueueCounterProps
 * @example - <CcfQueueCounter />
 * @returns
 */
export function CcfQueueCounter() {
  const styles = useStyles();
  const theme = useTheme();
  const [translate] = useTranslator();
  const appDirection: Direction = useSelector(getApplicationDirection);
  const isSmView = useMediaQuery(theme.breakpoints.down('xl'));

  return (
    <section className={styles.QueueCounterCard}>
      <Box className={styles.queueCounterHeader}>
        <CcfHeader
          LeftIcon={
            <CcfQueueIcon
              color="secondary"
              viewBox="-2 -2 23 23"
              fontSize="small"
            />
          }
          headerText={translate('queueCounter')}
          direction={appDirection}
        />
      </Box>
      <Box sx={{ height: '100%' }}>
        <CcfQueueCounterChannels isAppSpace={false} />
      </Box>
    </section>
  );
}

export default CcfQueueCounter;
